<template>
  <div>
    <v-container id="SeguimientoAddMov">
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <v-card flat class="text-xs-center mt-8" width="100%" height="auto">
              <v-card-title class="primary">
                <v-icon class="mr-2">mdi-badge-account-alert</v-icon>
                <v-toolbar-title id="titulocard">Agregar Movimiento</v-toolbar-title>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="full-height">
                <v-row justify="center" class="mt-2">
                  <v-col cols="12" lg="6">
                    <vs-list>
                      <span style=" text-align: center">
                        Tipo:</span>
                      <vs-list-item :subtitle="tipo"> </vs-list-item>
                    </vs-list>
                    <vs-list class="mt-2">
                      <span style=" text-align: center">
                        Respuesta:</span>
                      <br />
                      <span> {{ this.yes == true ? "SI" : "NO" }} </span>
                    </vs-list>
                  </v-col>
                </v-row>

                <!-- <v-row justify="center" class="my-2">
                  <v-col cols="12" lg="6">
                    <vs-list>
                      <span style="color: black; text-align: center">
                        Fecha:</span
                      >
                      <VueCtkDateTimePicker
                        v-model="fechaSelected"
                        :color="'blue'"
                        format="YYYY-MM-DD HH:mm"
                        formatted="ll hh:mm a"
                        :range="false"
                        :no-shortcuts="true"
                        :no-label="true"
                        label="Seleccione fecha"
                        :auto-close="true"
                        :only-date="true"
                        @input="activarAlert = false"
                        :input-size="'sm'"
                        :dark="informationPage.theme"
                        :minDate="minDate"
                        :maxDate="maxDate"
                        id="datapicker"
                        right
                      />
                    </vs-list>
                  </v-col>
                </v-row> -->

                <v-row justify="center" class="my-2">
                  <v-col cols="12" lg="6">
                    <vs-list>
                      <span style="text-align: center">
                        Fecha:</span>
                      <v-dialog ref="dialog" outlined v-model="modalFecha" :return-value.sync="fechaSelected" persistent
                        width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="textDate" label="" readonly :rules="rulestextfechas" outlined
                            v-bind="attrs" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="fechaSelected" :max="maxDate" :min="minDate" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modalFecha = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(fechaSelected)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </vs-list>
                  </v-col>
                </v-row>

                <!-- <v-row
                  justify="center"
                  class="my-2"
                  v-if="this.$route.params.opc == 823"
                >
                  <v-col cols="12" lg="6">
                    <v-divider></v-divider>
                    <ListaDocumentos :docs.sync="docs" />
                    <v-divider></v-divider>
                  </v-col>
                </v-row> -->
                
                <v-row justify="center" class="my-2">
                  <v-col cols="12" lg="6">
                    <vs-list>
                      <span style="text-align: center">
                        Observaciones:</span>
                      <v-form v-model="valid" ref="form" lazy-validation>
                        <v-textarea v-model="desc" @input="uppercase()" outlined :rules="descRules" :counter="500"
                          hide-details="auto"></v-textarea>
                      </v-form>
                    </vs-list>
                  </v-col>
                </v-row>
                <div class="mt-10"></div>

                <v-row justify="center" class="mb-8">
                  <v-btn class="ma-2" :loading="loading2" :disabled="!(valid && !validaemid)" color="#536DFE"
                    @click="RegistrarMovimiento()" style="color:white">
                    Guardar
                    <template v-slot:loader>
                      <span>Loading...</span>
                    </template>
                  </v-btn>
                  <v-btn class="ma-2" @click="clearForm()" color="default"> Limpiar </v-btn>

                  <v-btn class="ma-2" color="error" @click="goBackTo()">
                    Cancelar
                  </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import seguimientoService from "@/services/Seguimiento/seguimiento.service.js";
import ListaDocumentos from "@/components/pages/GestoriaDoc/ListaDocumentos.vue";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import moment from "moment";

export default {
  components: {
    ListaDocumentos,
  },
  data() {
    return {
      tipoAsistencia: [],
      modalFecha: false,

      docs: [],

      loading2: null,
      loading: null,
      date: null,
      textDate: null,

      desc: "",
      tipo: "",
      minDate: null,
      maxDate: null,
      fechaSelected: null,
      descRules: [
        (v) => !!v || "Campo requerido",
        (v) =>
          (v && v.length >= 12) ||
          "Mínimo 12 Carácteres",
        (v) =>
          (v && v.length <= 500) ||
          "Máximo 500 Carácteres",
      ],
      rulestextfechas: [v => !!v || 'Campo requerido'],

      recepDocIds: [],

      valid: true,
      yes: null,
      validaConclusion: false,
      estatus: [],
      status: null,
      validaemid: false,
      mostrarestatus: false,
      datos: null
    };
  },
  props: ["tAsistencia", "nrreporte", "svindice"],
  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
  },
  watch: {
    fechaSelected(val) {
      moment.locale("es-mx");
      let theDate = moment(val).format('ll');
      this.textDate = theDate;
    },
    'estatus.emid'(val) {
      this.estatus.emid = val
      this.validaemid = val != null ? false : true
    }
  },
  async mounted() {
    this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
    //console.log("El parametro bro: ", this.$route.params.opc , "el valor bro: ", this.$route.params.valor);
    this.obtenerEstadoReporte();
    this.ObtenenerDatosMovimiento();
    //if ([818, 817].includes(this.$route.params.opc)) {
    //  this.ObtenerEstatus()
    //} else {
    //  this.validaemid = false
    //}
  },
  methods: {
    async obtenerEstadoReporte() {
      this.validaConclusion = await MetodosGenerales.getReporteEstatus(this);
      if (this.validaConclusion == false) {
        this.goBackTo();
      }
    },

    async getYesAswered() {
      this.recepDocIds = [];
      this.docs.forEach((element) => {
        for (const [key, value] of Object.entries(element)) {
          if (value == undefined) {
            element[key] = null;
          }
          if (key == "gdrecepfisc" && value == true) {
            this.recepDocIds.push(element["gdid"]);
          }
        }
      });
    },

    uppercase() {
      if (this.desc != null) {
        this.desc = this.desc.toUpperCase();
      }
    },

    goBackTo() {
      this.$router.push({ name: "ReporteSeguimientoGD" });
    },

    clearForm() {
      this.$refs.form.reset()
      let today = moment().format("YYYY[-]MM[-]DD HH:mm");
      this.fechaSelected = today;
      this.desc = "";
      this.estatus.emid = ""
      this.validaemid = false
    },

    async ObtenenerDatosMovimiento() {
      //let reporte = JSON.parse(sessionStorage.getItem("reporte"));
      var respuesta = await seguimientoService.ObtenerDatosMovimientos(
        this.datos.nrreporte,
        this.datos.svindice,
        this.$route.params.opc
      );
      if (this.$route.params.opc == undefined) {
        this.goBackTo();
      } else {
        this.tipo = respuesta.TipoMovimiento.toUpperCase();
      }

      moment.locale("en");
      let auxMaxDate = moment().format("YYYY[-]MM[-]DD");
      this.maxDate = auxMaxDate;
      let today = moment().format("YYYY[-]MM[-]DD HH:mm");
      this.fechaSelected = today;
      let auxMinDate = respuesta.FechaReporte;
      this.minDate = auxMinDate.slice(0, 10);

      if ([818, 820, 823].includes(this.$route.params.opc)) {
        if (this.$route.params.valor == 3) {
          this.yes = true;
        }
      } else {
        if (this.$route.params.valor == 1) {
          this.yes = true;
        }
      }
    },

    async RegistrarMovimiento() {
      this.desc = this.desc.trim();

      
      await this.$refs.form.validate();
      if (this.$refs.form.validate() && !this.validaemid) {
        //let reporte = JSON.parse(sessionStorage.getItem("reporte"));
        let exresp = null;

        if ([818, 823].includes(this.$route.params.opc)) {
          if (this.$route.params.valor == 3) {
            exresp = "S";
          }
          if (this.$route.params.valor == 1) {
            exresp = "N";
          }
        } else {
          if (this.$route.params.valor == 1) {
            exresp = "S";
          }
          if (this.$route.params.valor == 0) {
            exresp = "N";
          }
        }

        this.$swal({
          title: "Cargando...",
          html: "Guardando movimiento, espere un momento....",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        this.$swal.showLoading();
        this.getYesAswered();

        if (this.$route.params.opc == 823) {
          //console.log("El LENGTH DEL DOC: ",this.docs.length , " EL LENGHT DEL RECEPDOCID:", this.recepDocIds.length );
          if (this.docs.length == this.recepDocIds.length && exresp == "N") {
            this.$swal.close();
            this.$swal({
              position: "center",
              icon: "warning",
              title: "Advertencia",
              text: "Si todos los documentos se han recibido, por favor seleccione respuesta SI en la ventana anterior",
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonText: "Ok!",
              timer: 4000,
            });
          } else if (
            this.docs.length > this.recepDocIds.length &&
            exresp == "S"
          ) {
            this.$swal.close();
            this.$swal({
              position: "center",
              icon: "warning",
              title: "Advertencia",
              text: "Si no se han recibido todos los documentos, por favor seleccione respuesta NO en la ventana anterior",
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonText: "Ok!",
              timer: 4000,
            });
          } else {
            let ids = "empty";
            //console.log("EL RECEP ID: ", this.recepDocIds);
            if (this.recepDocIds.length == 0) {
              ids = "empty";
            } else {
              ids = this.recepDocIds.toString();
            }
            var respuesta =
              await seguimientoService.RegistrarMovimientoRecepFisc(
                this.datos.nrreporte,
                this.datos.svindice,
                this.$route.params.opc,
                exresp,
                this.desc,
                this.fechaSelected,
                ids
              );
            this.$swal.close();
            if (respuesta.success == "true") {
              this.$swal({
                position: "center",
                icon: "success",
                title: "Éxito",
                text: "Se agregó el movimiento correctamente",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: true,
                timer: 4000,
                timerProgressBar: true,
                confirmButtonText: "Ok!",
                willClose: () => {
                  this.goBackTo();
                }
              });
            } else {
              this.$swal({
                position: "center",
                icon: "error",
                title: "Error",
                text: "No se pudo realizar el movimiento por favor intente de nuevo mas tarde, si el problema persiste ponganse en contacto con el equipo de asistencia tecnica",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: true,
                confirmButtonText: "Ok!",
              });
            }
          }
        } else {
          var respuesta = await seguimientoService.RegistrarMovimiento(
            this.datos.nrreporte,
            this.datos.svindice,
            this.$route.params.opc,
            exresp,
            this.desc,
            this.fechaSelected
          );

          

          this.$swal.close();
          if (respuesta.success == "true") {
            this.$swal({
              position: "center",
              icon: "success",
              title: "Éxito",
              text: "Se agregó el movimiento correctamente",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: true,
              confirmButtonText: "Ok!",
              timer: 4000,
              willClose: () => {
                this.goBackTo();
              }
            });
          } else {
            this.$swal({
              position: "center",
              icon: "error",
              title: "Error",
              text: "No se pudo realizar el movimiento por favor intente de nuevo mas tarde, si el problema persiste ponganse en contacto con el equipo de asistencia tecnica",
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: true,
              confirmButtonText: "Ok!",
            });
          }
        }
      } else {
        if (this.mostrarestatus) { this.validaemid = true }

      }
    },

    //async ObtenerEstatus() {
    //  this.estatus = await seguimientoService.Estatus(this)
    //  this.mostrarestatus = true
    //}
  },
};
</script>

<style>
#SeguimientoAddMov .vs-list--title {
  font-size: 0.8rem !important;
  font-weight: 700 !important;
}

#SeguimientoAddMov .vs-list--subtitle {
  font-size: 1.3rem !important;
  font-weight: 700 !important;
}

.full-height {
  height: auto;
}

#SeguimientoAddMov .theme--light.v-card>.v-card__text,
.theme--light.v-card>.v-card__subtitle {
  color: rgba(0, 0, 0, 1);
}

#SeguimientoAddMov .theme--dark.v-card>.v-card__text,
.theme--dark.v-card>.v-card__subtitle {
  color: rgba(255, 255, 255, 1);
}
</style>